import type { Phone } from '../types'
import { PhonePicker } from './PhonePicker'
import { CallBoostPanel } from './CallBoostPanel'

interface Props {
  phones: Phone[]
  activeId: string | null
  onPick: (id: string) => void
  locked: boolean
  onLogout: () => void
}

export function OperatorSidebar({ phones, activeId, onPick, locked, onLogout }: Props) {
  return (
    <aside className="hidden md:flex w-72 shrink-0 flex-col border-r border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900">
      <div className="px-5 py-5 border-b border-gray-200 dark:border-gray-800">
        <h1 className="text-base font-semibold tracking-tight text-gray-900 dark:text-gray-100">
          МММ
        </h1>
        <p className="text-[11px] text-gray-500 dark:text-gray-500 mt-0.5">
          Operator Console
        </p>
      </div>

      <div className="px-3 py-4 border-b border-gray-200 dark:border-gray-800">
        <CallBoostPanel controlsTestId="sidebar-boost" />
      </div>

      <nav className="flex-1 overflow-y-auto p-3">
        <p className="px-2 pb-2 text-[11px] font-mono uppercase tracking-wider text-gray-500 dark:text-gray-500">
          Трубки ({phones.length})
        </p>
        <PhonePicker
          phones={phones}
          activeId={activeId}
          onPick={onPick}
          locked={locked}
          layout="vertical"
        />
      </nav>

      <div className="p-3 border-t border-gray-200 dark:border-gray-800">
        <button
          type="button"
          onClick={onLogout}
          className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
        >
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
          Выйти
        </button>
      </div>
    </aside>
  )
}
